module.exports = __webpack_public_path__ + "static/media/99gal46.87691963.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/99gal/99gal46.jpg
// module id = 383
// module chunks = 0